export const fontSizesList = [
  { id: 0, label: 2 },
  { id: 1, label: 4 },
  { id: 2, label: 6 },
  { id: 3, label: 8 },
  { id: 4, label: 10 },
  { id: 5, label: 11 },
  { id: 6, label: 12 },
  { id: 7, label: 13 },
  { id: 8, label: 14 },
  { id: 9, label: 15 },
  { id: 10, label: 16 },
  { id: 11, label: 17 },
  { id: 12, label: 18 },
  { id: 13, label: 19 },
  { id: 14, label: 20 },
  { id: 15, label: 21 },
  { id: 16, label: 22 },
  { id: 17, label: 23 },
  { id: 18, label: 24 },
  { id: 19, label: 25 },
  { id: 20, label: 26 },
  { id: 21, label: 27 },
  { id: 22, label: 28 },
  { id: 23, label: 29 },
  { id: 24, label: 30 },
  { id: 25, label: 32 },
  { id: 26, label: 34 },
  { id: 27, label: 36 },
  { id: 28, label: 38 },
  { id: 29, label: 40 },
  { id: 30, label: 42 },
  { id: 31, label: 44 },
  { id: 32, label: 48 },
  { id: 33, label: 50 },
  { id: 34, label: 54 },
  { id: 35, label: 58 },
  { id: 36, label: 64 },
  { id: 37, label: 68 },
  { id: 38, label: 72 },
  { id: 39, label: 74 },
  { id: 40, label: 78 },
  { id: 41, label: 84 },
  { id: 42, label: 88 },
  { id: 43, label: 96 },
  { id: 44, label: 98 },
  { id: 45, label: 102 },
  { id: 46, label: 108 },
  { id: 47, label: 112 },
  { id: 48, label: 114 },
  { id: 49, label: 116 },
  { id: 50, label: 118 },
  { id: 51, label: 120 },
  { id: 52, label: 124 },
  { id: 53, label: 128 },
  { id: 54, label: 132 },
  { id: 55, label: 138 },
];
